import { render, staticRenderFns } from "./RepartidoresEdit.vue?vue&type=template&id=331b89dc&"
import script from "./RepartidoresEdit.vue?vue&type=script&lang=js&"
export * from "./RepartidoresEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports